import { render, staticRenderFns } from "./PropertiesDataTable.vue?vue&type=template&id=417f881a"
import script from "./PropertiesDataTable.vue?vue&type=script&lang=js"
export * from "./PropertiesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports